import _ from "lodash";
import TableReportHelper from "report/helper";
import { getTalhaoNomeDisplay, getTalhaoAreaDisplay } from "entity/Indicador/reports/talhaoDisplay";

// TODO: padronizar 'apontamentoHeaderReport' para remover este arquivo.
export default function ttcHeaderReport(visita, indicador, apontamento, params, optLabelConformidade) {
    const h = new TableReportHelper(apontamento);
    const IndicadorClass = indicador.constructor;

    const nomeAmostra = `${IndicadorClass.fullName} - ${IndicadorClass.abbrev}`;
    const status = IndicadorClass.getConformidadeStatus(
        apontamento.conformidade,
        params?.meta,
        apontamento,
        visita.cliente,
    );

    let conformidade = Math.abs(apontamento.conformidade);
    let suffix = apontamento.conformidade < 0 ? "% < meta" : "% > meta";

    if (_.isEmpty(params)) {
        return h.panel(
            [
                // prettier-ignore
                h.row(
                    h.title("Amostra"),
                    h.text(nomeAmostra)
                ),

                h.row(
                    h.title("ATENÇÃO: Não existem parâmetros configurados no cliente para este indicador.", {
                        colSpan: 2,
                    }),
                ),
            ],
            { widths: [60, "*"] },
        );
    }

    const content = [
        h.panel(
            [
                h.row(
                    h.title("Amostra"),
                    h.text(nomeAmostra),
                    h.title("Tipo"),
                    h.textField("tipo"),
                    h.title("Meta (mm:ss)"),
                    h.text(params.meta),
                ),
            ],
            { widths: [60, "*", 60, 70, 65, 40] },
        ),

        h.panel(
            [
                // prettier-ignore
                h.row(
                    h.title("Talhão"),
                    h.title("Área (ha)"),
                    h.title("Trator"),
                    h.title("Implemento"),
                    h.title("Frente"),
                    h.title("Turno")
                ),

                h.row(
                    h.text(getTalhaoNomeDisplay(apontamento)),
                    h.text(getTalhaoAreaDisplay(apontamento)),
                    h.textField("trator.numeroFrotaTrator"),
                    h.textField("implemento.numeroFrotaImplemento"),
                    h.textField("frente"),
                    h.textField("turno"),
                ),
            ],
            { widths: [60, 70, "*", "*", 125, 90] },
        ),

        h.panel(
            [
                h.row(
                    h.title("Operador"),
                    h.title("Tempo Registrado (mm:ss) "),
                    h.title("Resto (segundos)"),
                    h.title("Localização"),
                    h.title(optLabelConformidade || "Resultado (%)", { alignment: "right" }),
                ),

                h.row(
                    h.textField("operador"),
                    h.textField("tempoRegistrado"),
                    h.textField("resto"),
                    h.locationField("georeferencia"),
                    h.conformidade(conformidade, status, { suffix: suffix, alignment: "right" }),
                ),
            ],
            { widths: ["*", "*", "*", 90, 90] },
        ),
    ];

    return h.unbreakable(content);
}
